import React, { useState } from "react";
import { Button, Card, CardContent, Grid, Typography } from "@material-ui/core";
import { usePackagesStyles } from "./useStyles";
import { createStripePaymentLink } from "../../../api/signupApi";
import { useSelector } from "react-redux";
import { getCookieOfThirdParty } from "../../../helpers/Cookie";
import Utils from "../../../helpers/Utils";

const MAX_VISIBLE_FEATURES = 4;

const PackageItem = ({ plan }) => {
    const classes = usePackagesStyles();
    const { agencyId, fullName, phoneNumber, email, aboutUsItem, companyCategory } = useSelector((state) => (state.signupReducer));
    const [showAll, setShowAll] = useState(false);
    const [gettingStated, setGettingStarted] = useState(false);

    const toggleShowAll = () => {
        setShowAll(prev => !prev);
    };

    const visibleFeatures = showAll ? plan.features : plan.features.slice(0, MAX_VISIBLE_FEATURES);

    const buyPackage = async () => {
        try {
            setGettingStarted(true);
            const payload = {
                agencyId: agencyId,
                subscriptionPlanId: `${plan.plan_id}`,
                stripeProductPriceId: plan.stripe_price_id,
                userSignupData: {
                    name: fullName,
                    full_name: fullName,
                    phone: phoneNumber,
                    email: email,
                    about_us_item: aboutUsItem,
                    company_category_id: companyCategory,
                    agency_id: agencyId
                }
            }

            const res = await createStripePaymentLink(payload);
            if (res.data.success && res.data.data.paymentUrl) {
                const firstPromoterTID = getCookieOfThirdParty('_fprom_tid');
                if (firstPromoterTID) {
                    let url = new URL(res.data.data.paymentUrl);
                    url.searchParams.set('client_reference_id', firstPromoterTID);
                    // const firstPromoterTrack = getCookieOfThirdParty('_fprom_track');
                    // const firstPromoterCode = getCookieOfThirdParty('_fprom_code');
                    if (url.href) {
                        window.location.href = url.href;
                    } else {
                        window.location.href = res.data.data.paymentUrl;

                    }
                } else {
                    window.location.href = res.data.data.paymentUrl;
                }
            }
            setGettingStarted(false);
        } catch (err) {
            console.log(err);
            setGettingStarted(false);
        }
    };

    return (
        <Grid className={classes.gridItem} item>
            {
                plan.current_plan ?
                    <div className={classes.trapezium}>
                        Your Current Plan
                    </div> :
                    null
            }

            <Card className={`${classes.card} ${plan.current_plan ? ' currentPlan' : ''}`}>
                {
                    plan.custom ?
                        <div className={classes.ribbon}>
                            <Typography variant="caption" style={{ height: 'unset !important' }}>Only for you</Typography>
                        </div> :
                        null
                }

                <CardContent>
                    <Typography variant={'h6'} gutterBottom style={{ height: 'unset !important' }}>
                        {plan.title}
                    </Typography>
                    <Typography className={classes.price} style={{ height: 'unset !important' }}>
                        ${Utils.fixDecimal(plan.price)}{' '}
                        {plan.price_type === 'CUSTOM' && plan.validity && (
                            <span className={classes.validity}>/ {plan.validity} days</span>
                        )}
                    </Typography>
                    <Typography className={classes.description} style={{ height: 'unset !important' }}>
                        {plan.description}
                    </Typography>
                    <div className={classes.features}>
                        {
                            visibleFeatures.map((feature, idx) => (
                                <Typography key={idx} className={classes.feature} style={{ height: 'unset !important' }}>
                                    {feature}
                                </Typography>
                            ))
                        }
                    </div>

                    {
                        plan.features.length > MAX_VISIBLE_FEATURES && (
                            <div className={classes.seeMore}>
                                <span className={classes.seeMoreButton} onClick={toggleShowAll}>
                                    {showAll ? 'See less' : 'See more'}
                                </span>
                            </div>
                        )
                    }
                </CardContent>

                <Button
                    variant={'contained'}
                    color={'primary'}
                    className={classes.button}
                    fullWidth
                    onClick={buyPackage}
                    disabled={gettingStated}
                >
                    {
                        gettingStated ?
                            'Getting Started...' :
                            plan.trial_period !== undefined &&
                                plan.trial_period !== null ?
                                `Start ${plan.trial_period}-Day Trial` :
                                'Get Started'
                    }
                </Button>
            </Card>
        </Grid>
    );
};

export default PackageItem;